import { render, staticRenderFns } from "./InvoiceTableSkeletonItem.vue?vue&type=template&id=4a71054e&scoped=true"
import script from "./InvoiceTableSkeletonItem.vue?vue&type=script&lang=js"
export * from "./InvoiceTableSkeletonItem.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTableSkeletonItem.vue?vue&type=style&index=0&id=4a71054e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71054e",
  null
  
)

export default component.exports